export default "__VITE_ASSET__953852e0__"